module.exports = __webpack_public_path__ + "img/Media-LinkedIn.ac4ceef2.svg";